import { Brain } from "lucide-react";

/**
 * Route Transition Loading Component
 * Displays during lazy-loaded route transitions
 */
export function RouteTransition() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="text-center space-y-4 px-4">
        {/* Animated Brain Icon */}
        <div className="flex justify-center">
          <div className="relative w-16 h-16">
            {/* Pulsing background */}
            <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/20 to-blue-600/20 rounded-full animate-ping"></div>
            
            {/* Icon container */}
            <div className="relative w-16 h-16 rounded-full bg-gradient-to-br from-cyan-500 to-blue-600 flex items-center justify-center shadow-lg shadow-blue-500/30 animate-pulse">
              <Brain className="w-8 h-8 text-white" />
            </div>
          </div>
        </div>

        {/* Loading text */}
        <div className="space-y-1">
          <p className="text-sm font-medium text-muted-foreground">Loading...</p>
        </div>
      </div>
    </div>
  );
}

/**
 * Minimal Loading Spinner
 * For inline loading states
 */
export function LoadingSpinner({ size = "md", className = "" }: { size?: "sm" | "md" | "lg"; className?: string }) {
  const sizeClasses = {
    sm: "w-4 h-4 border-2",
    md: "w-8 h-8 border-3",
    lg: "w-12 h-12 border-4"
  };

  return (
    <div className={`inline-block ${sizeClasses[size]} border-cyan-500 border-t-transparent rounded-full animate-spin ${className}`}></div>
  );
}
